import { styled } from "styled-components";

const Section = ({
  children,
  id,
}: {
  children: JSX.Element[];
  id?: string;
}) => {
  return <StyledSection id={id}>{children}</StyledSection>;
};

const StyledSection = styled.section`
  position: relative;
  margin-top: 150px;
  margin-bottom: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 93%;
  max-width: 1000px;
  padding-top: 40px;
`;

export const StyledSectionImage = styled.img`
  position: absolute;
  top: 25px;
  right: 20px;
  width: 30px;
`;

export default Section;
